import { createAction } from '@reduxjs/toolkit'

export const ProjectAvatarActions = {
  upload: createAction<FileList | null>('UPLOAD_PROJECT_AVATAR'),
  reset: createAction('RESET_PROJECT_AVATAR'),
}
